<template>
  <div class="route-elevation">
    <canvas
      class="route-elevation-graph"
      ref="chart"
      :width="360"
      :height="60"
      @mouseout="mouseout"
    />
    <div class="route-elevation-info">
      <!-- <div>
        <FlatIcon
          name="el-dist"
          :size="18" />
        {{ total }}
      </div> -->
      <div>
        <FlatIcon
          name="el-climb"
          :size="18"
        />
        {{ climbing }}
        <FlatIcon
          name="el-down"
          :size="18"
        />
        {{ descent }}
      </div>
      <div>
        <FlatIcon
          name="el-min"
          :size="18"
        />
        {{ altitudeMin }}
        <FlatIcon
          name="el-max"
          :size="18"
        />
        {{ altitudeMax }}
      </div>
    </div>

  </div>
</template>

<script>
import Chart from 'chart.js'
import * as ChartAnnotation from 'chartjs-plugin-annotation'
import { mapGetters } from 'vuex'
import convert from 'convert-units'
import { coordinatesElevation } from './utils'

export default {
  name: 'RouteElevation',
  props: {
    points: {
      type: Array,
      required: true
    },
    distance: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      chart: null
    }
  },
  computed: {
    ...mapGetters({
      setting: 'global/setting'
    }),
    unit () {
      return this.setting('km') ? 'km' : 'mi'
    },
    elevationData () {
      return coordinatesElevation(this.points)
    },
    altitudeMin () {
      return this.convertMeters(this.elevationData.min)
    },
    altitudeMax () {
      return this.convertMeters(this.elevationData.max)
    },
    climbing () {
      return this.convertMeters(this.elevationData.up)
    },
    descent () {
      return this.convertMeters(this.elevationData.dw)
    },
    total () {
      let d = convert(this.elevationData.d).from('km').to(this.unit)
      d = convert(d).from(this.unit).toBest()
      return parseFloat(d.val.toFixed(1)).toLocaleString() + ' ' + d.unit
    },
    chartData () {
      return {
        datasets: [{
          label: 'Elevation',
          showLine: true,
          pointRadius: 0,
          hitRadius: 0,
          hoverRadius: 0,
          borderWidth: 1,
          borderColor: '#2da0d4',
          backgroundColor: 'rgba(45, 160, 212, 0.1)',
          data: this.elevationData.xy
        }]
      }
    },
    chartOptions () {
      return {
        annotation: {
          annotations: [
            {
              type: 'line',
              mode: 'vertical',
              scaleID: 'x-axis-1',
              value: this.distance.toString(),
              borderColor: 'rgba(251, 176, 59, 1)',
              borderWidth: 1,
              label: {
                backgroundColor: 'rgba(251, 176, 59, 1)',
                enabled: true,
                content: this.convertMeters(this.distance),
                position: 'top'
              }
            }
          ]
        },
        onClick: this.click,
        onHover: this.hover,
        animation: {
          duration: 0
        },
        tooltips: {
          mode: 'nearest',
          intersect: false,
          displayColors: false,
          callbacks: {
            label: this.tooltipLabel
          },
          backgroundColor: '#2da0d4'
        },
        legend: {
          display: false
        },
        layout: {
          padding: {
            top: 0,
            left: -10,
            right: 0,
            bottom: -20
          }
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              },
              ticks: {
                display: false,
                stepSize: 1,
                callback: this.ticksValues,
                autoSkip: true,
                maxTicksLimit: 6,
                max: Math.round(this.elevationData.d * 1000)
              }
            },
            {
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              // callback: this.ticksValues,
              // autoSkip: true,
              min: 0,
              display: false
            }
          }]
        }
      }
    }
  },
  watch: {
    distance (dist) {
      let annotation = this.chart.options.annotation.annotations[0]
      annotation.value = dist.toString()
      annotation.label.content = this.convertMeters(dist)
      this.chart.update()
    },
    points () {
      if (this.chart) {
        this.chart.destroy()
        this.chart = null
      }
      this.renderChart()
    }
  },
  methods: {
    ticksValues (m) {
      return this.convertMeters(m)
    },
    convertMeters (m) {
      let d = convert(m).from('m').to(this.unit)
      d = convert(d).from(this.unit).toBest()
      return parseFloat(d.val.toFixed(1)).toLocaleString() + ' ' + d.unit
    },
    renderChart () {
      this.chart = new Chart(this.$refs.chart.getContext('2d'), {
        type: 'scatter',
        plugins: [ChartAnnotation],
        data: this.chartData,
        options: this.chartOptions
      })
    },
    tooltipLabel (item) {
      const coords = this.points[item.index]
      this.$emit('hover', coords)
      return this.convertMeters(item.value)
    },
    mouseout () {
      this.$emit('hover', null)
    }
  },
  mounted () {
    this.renderChart()
  }
}
</script>

<style lang="scss">
.route-elevation-graph {
  padding: 0;
  margin: 0;
}
.route-elevation-info {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  padding-left: var(--f7-list-item-padding-horizontal);
  padding-right: var(--f7-list-item-padding-horizontal);
  color: var(--f7-list-item-footer-text-color);
  font-size: var(--f7-list-item-footer-font-size);
  font-weight: var(--f7-list-item-footer-font-weight);
  line-height: var(--f7-list-item-footer-line-height);
}
</style>
